export default __webpack_public_path__ + "static/media/background.461ba86c.png";